import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

export const WhyUsHero = () => (
  <section className="py-24 bg-[#f8fafc]" data-testid="why-us-hero">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <div className="grid lg:grid-cols-2 gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
        >
          <span className="inline-block px-4 py-2 bg-white rounded-full text-sm font-medium text-[#3b5998] mb-6 shadow-sm">
            Why Choose Us
          </span>
          <h1 className="font-heading text-4xl sm:text-5xl font-semibold text-[#0f172a] leading-tight mb-6">
            A Decade of
            <span className="gradient-text block">Trust & Excellence</span>
          </h1>
          <p className="text-lg text-[#64748b] leading-relaxed mb-6">
            Since 2014, Thesaurus of Finance has been a trusted partner for businesses 
            and individuals seeking expert guidance in government subsidies and financial solutions. 
            Our commitment to transparency, expertise, and results sets us apart.
          </p>
          <div className="flex flex-wrap gap-8 mb-8">
            <div>
              <p className="stat-number text-4xl font-semibold">500+</p>
              <p className="text-[#64748b] text-sm">Clients Served</p>
            </div>
            <div>
              <p className="stat-number text-4xl font-semibold">₹100Cr+</p>
              <p className="text-[#64748b] text-sm">Funds Facilitated</p>
            </div>
            <div>
              <p className="stat-number text-4xl font-semibold">98%</p>
              <p className="text-[#64748b] text-sm">Success Rate</p>
            </div>
          </div>
          <Link
            to="/contact"
            data-testid="why-us-cta"
            className="inline-flex items-center gap-2 gradient-btn px-8 py-4 rounded-full font-medium text-white"
          >
            Start Your Journey
            <ArrowRight size={18} />
          </Link>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, x: 30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <img
            src="https://images.pexels.com/photos/955394/pexels-photo-955394.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
            alt="Professional consultation"
            className="rounded-2xl shadow-2xl w-full h-[450px] object-cover"
          />
        </motion.div>
      </div>
    </div>
  </section>
);
